import React from 'react'
import Icon from './Icons'


class ChoiceBlock extends React.Component{

  render() {

    return(
      
      <div className='heroDevice-screen-mainPanel-choiceBlock'>        
        <div className='heroDevice-screen-mainPanel-choiceBlock-choiceText'>
        	{this.props.label}
        </div>
        <div style={{width: `${this.props.width}%`}} className={'heroDevice-screen-mainPanel-choiceBlock-bar ' + (this.props.correct ? 'heroDevice-screen-mainPanel-choiceBlock-bar--correct' : 'heroDevice-screen-mainPanel-choiceBlock-bar--incorrect')}/>
        <div className='heroDevice-screen-mainPanel-choiceBlock-track' />
      </div>
      
    )
  }}

 
class HeroDevice extends React.Component{

  render() {

    return(
      
      <div className='heroDevice'>
      	<Icon iconName='sensor-array' />      	
        <div className='heroDevice-screen'>
        	<div className='heroDevice-screen-mainPanel'>
        		<div className='heroDevice-screen-mainPanel-topMarkRow'>
        			<div className='heroDevice-screen-mainPanel-topMarkRow-left'/>
        			<div className='heroDevice-screen-mainPanel-topMarkRow-right'/>
        		</div>
        		<div className='heroDevice-screen-mainPanel-title'>
        			What's the heaviest planet in our Solar System?
        		</div>

        		<div className='heroDevice-screen-mainPanel-choiceBlockContainer'>
        			<ChoiceBlock label='Venus' incorrect width={6} />
        			<ChoiceBlock label='Jupiter' correct width={80} />
        			<ChoiceBlock label='Neptune' incorrect width={10}  />
        			<ChoiceBlock label='Mars' incorrect  width={4} />
        		</div>

        		<div className='heroDevice-screen-mainPanel-summaryMarkRow'>
        				<div className='heroDevice-screen-mainPanel-summaryMarkRow-mark'/>
        				<div className='heroDevice-screen-mainPanel-summaryMarkRow-mark'/>
        				<div className='heroDevice-screen-mainPanel-summaryMarkRow-mark'/>
        		</div>

        		<div className='heroDevice-screen-mainPanel-bottomControls'>
        			<div className='heroDevice-screen-mainPanel-bottomControls-navControl heroDevice-screen-mainPanel-bottomControls-navControl--prev'>
        				<Icon iconName='nav-previous' />
        			</div>
        			<div className='heroDevice-screen-mainPanel-bottomControls-scanCircle' />
        			<div className='heroDevice-screen-mainPanel-bottomControls-navControl heroDevice-screen-mainPanel-bottomControls-navControl--next'>
        				<Icon iconName='nav-previous' />
        			</div>
        		</div>

        	</div>
        	<div className='heroDevice-screen-backPanel'/>
        </div>
      </div>
      
    )
  }}
   

export default HeroDevice
